// Для будущих нотификаций лучше все это добавить на стороне бека, но если не получится,
// то добавить сюда тип оплаты и создать константу с именованием кода страны и значением ключа от перевода.
// Далее в объекте типов нотификаций по ключу, который из себя представляет идишник тип оплаты, перечислить
// коды стран, для которых нужна нотификация для этого типа оплаты. Нотификация проставится сама к нужному блоку.
const ID_CASH = '24'
const ID_BANK_CARD_QATAR = '99'
const ID_BANK_TRANSFER_DE = '16'
const CCIText = 'cci_poland_notification_text'
const QAText = 'payment_notification_qatar'
const DEText = 'payment_notification_de_countries'

const NOTIFICATION_TYPES = {
  [ID_CASH]: { CCI: CCIText, PL: CCIText },
  [ID_BANK_CARD_QATAR]: { QA: QAText },
  [ID_BANK_TRANSFER_DE]: { DE: DEText, AT: DEText, CH: DEText },
}

export const notificationText = (selectedMethodId, curLocationFromStore) => {
  const { CODE, ALPHA2 } = curLocationFromStore

  return (
    NOTIFICATION_TYPES[selectedMethodId] &&
    NOTIFICATION_TYPES[selectedMethodId][CODE === 'CCI' ? CODE : ALPHA2]
  )
}
